import React, { PureComponent, PropTypes } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Carousel } from 'react-responsive-carousel';
import '../../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
import { Employee, Hand, IpadAnimated,
  Checkout } from './shared';
import { Button } from '../shared/button';
import styles from './styles.scss';
import messages from './i18n';
import { IpadStandard, Laptop, Clockin } from '../../shared';

export class SignUpCarousel extends PureComponent {
  render() {
    return (
      <div>
        <Carousel emulateTouch showStatus={false} showThumbs={false}>
          <div className={styles.layout}>
            <div className={styles.container}>
              <div className={styles.imageContainer}>
                <Checkout
                  className={styles.checkout}
                />
                <Employee
                  className={styles.employee}
                />
                <IpadStandard
                  className={styles.wallIpad}
                />
              </div>
              <div className={styles.text}>
                <div className={styles.heading}>
                  <FormattedMessage {...messages.firstSlideHeading} />
                </div>
                <div className={styles.body}>
                  <FormattedMessage {...messages.firstSlideBody} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.layout}>
            <div className={styles.container}>
              <div className={styles.imageContainer}>
                <IpadAnimated
                  className={styles.ipadAnimated}
                />
                <Hand
                  className={styles.hand}
                />
              </div>
              <div className={styles.text}>
                <div className={styles.heading}>
                  <FormattedMessage {...messages.secondSlideHeading} />
                </div>
                <div className={styles.body}>
                  <FormattedMessage {...messages.secondSlideBody} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.layout}>
            <div className={styles.container}>
              <div className={styles.imageContainer}>
                <IpadStandard
                  className={styles.clockinIpad}
                />
                <Clockin
                  className={styles.clockin}
                />
                <Laptop
                  className={styles.laptop}
                />
              </div>
              <div className={styles.text}>
                <div className={styles.heading}>
                  <FormattedMessage {...messages.thirdSlideHeading} />
                </div>
                <div className={styles.body}>
                  <FormattedMessage {...messages.thirdSlideBody} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.layout}>
            <div className={styles.confirmationContainer}>
              <div className={styles.heading}>
                <FormattedMessage {...messages.fourthSlideHeading} />
              </div>
              <div className={styles.passcodeContainer}>
                <div className={styles.digitPlaceholder}>
                  <div className={styles.digit}>1</div>
                </div>
                <div className={styles.digitPlaceholder}>
                  <div className={styles.digit}>2</div>
                </div>
                <div className={styles.digitPlaceholder}>
                  <div className={styles.digit}>3</div>
                </div>
                <div className={styles.digitPlaceholder}>
                  <div className={styles.digit}>4</div>
                </div>
              </div>
              <Button
                className={styles.getStartedButton}
                label={this.props.intl.formatMessage(messages.getStartedButton)}
                onClick={this.props.signUpGotoTimeClock}
                primary
              />
            </div>
          </div>
        </Carousel>
      </div>
    );
  }
}

SignUpCarousel.propTypes = {
  signUpGotoTimeClock: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(SignUpCarousel);



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/index.jsx